import { render, staticRenderFns } from "./TableChartConfigure.vue?vue&type=template&id=3857be13&scoped=true&"
import script from "./TableChartConfigure.vue?vue&type=script&lang=js&"
export * from "./TableChartConfigure.vue?vue&type=script&lang=js&"
import style0 from "./TableChartConfigure.vue?vue&type=style&index=0&id=3857be13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857be13",
  null
  
)

export default component.exports